import { graphqlClient } from '@/lib/graphql-client';
import {
  buildGetDepartmentsLookupQuery,
  buildGetEmployeesLookupQuery,
  buildGetPotentialProfilesQuery,
} from '../graphql/queries';
import {
  DELETE_POTENTIAL_PROFILE_MUTATION,
  INSERT_CONDITIONAL_OFFER_MUTATION,
  INSERT_POTENTIAL_PROFILE_MUTATION,
} from '../graphql/mutations';
import {
  DepartmentOption,
  EmployeesLookupResult,
  GetPotentialProfilesParams,
  InterviewPanelMember,
  PotentialProfile,
  PotentialProfileInsertInput,
  PotentialProfilesPagingResult,
} from '../types/profile.types';

export const getPotentialProfiles = async (
  params: GetPotentialProfilesParams
): Promise<{ PotentialProfiles: PotentialProfilesPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetPotentialProfilesQuery(filter, pageNo, pageSize, order),
  });
};

export const getDepartmentsLookup = async (): Promise<{
  Departments: { items: DepartmentOption[] };
}> => {
  return graphqlClient.query({
    query: buildGetDepartmentsLookupQuery({}, 1, 300),
  });
};

export const getEmployeesLookup = async (
  keyword = ''
): Promise<{ Employees: EmployeesLookupResult }> => {
  const filter = keyword ? { DisplayName: { $regex: keyword, $options: 'i' } } : {};
  return graphqlClient.query({
    query: buildGetEmployeesLookupQuery(filter, 1, 50),
  });
};

export const createPotentialProfile = async (input: PotentialProfileInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_POTENTIAL_PROFILE_MUTATION, variables: { input } });
};

export const deletePotentialProfile = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_POTENTIAL_PROFILE_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};

export const transferToConditionalOffer = async (params: {
  profile: PotentialProfile;
  departmentId: string;
  departmentName: string;
  interviewPanel: InterviewPanelMember[];
}) => {
  await graphqlClient.mutate({
    query: INSERT_CONDITIONAL_OFFER_MUTATION,
    variables: {
      input: {
        SourcePotentialProfileId: params.profile.ItemId,
        FirstName: params.profile.FirstName,
        LastName: params.profile.LastName,
        PhoneNumber: params.profile.PhoneNumber,
        Email: params.profile.Email,
        Designation: params.profile.Designation,
        YearsOfExperience: params.profile.YearsOfExperience,
        Source: params.profile.Source,
        HiringDepartmentId: params.departmentId,
        HiringDepartmentName: params.departmentName,
        InterviewPanelJson: JSON.stringify(params.interviewPanel),
      },
    },
  });
  await deletePotentialProfile(params.profile.ItemId);
};
